import { IconIconAttribute } from '@wisereducacao-npm/design-system-core-web/dist/components/icon/types';

export const getSuccessType = ({
  isBankslip,
  showUpsellComunication,
  isSuccessUpsellScreen = false,
  shouldRedirectToWhatsApp = false,
}) => {
  if (isBankslip) return 'bankslip';

  if (shouldRedirectToWhatsApp) return 'upsellWithWhatsapp';

  if (showUpsellComunication) return 'upsell';

  if (isSuccessUpsellScreen) return 'successMessageUpsell';

  return 'default';
};

export const formatTextBasedOnProductName = (
  text = '',
  mainProductName = '',
  upsellProductName = '',
  liveloPoints = 0
) => {
  const formatLiveloPoints = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
  });

  return text
    ?.replace('{MAIN_PRODUCT_NAME}', mainProductName)
    ?.replace('{UPSELL_PRODUCT_NAME}', upsellProductName)
    ?.replace(
      '{LIVELO_POINTS}',
      formatLiveloPoints.format(liveloPoints)?.toString()
    );
};

export type SuccessTypes =
  | 'bankslip'
  | 'upsell'
  | 'default'
  | 'successMessage'
  | 'successMessageUpsell'
  | 'upsellWithWhatsapp';

export interface SuccessContent {
  title: string;
  icon: string;
  subtitle?: string;
  description?: string;
  offerMessage?: string;
  button?: {
    text: string;
    icon?: IconIconAttribute;
  };
}

export interface SuccessContentProps {
  default?: SuccessContent;
  upsell?: SuccessContent;
  bankslip?: SuccessContent;
  successMessage?: SuccessContent;
  successMessageUpsell?: SuccessContent;
}

interface GetSuccessObjInfosProps {
  successType: SuccessTypes;
  successContent: SuccessContentProps;
  isSuccessUpsellScreen?: boolean;
}

export const getSuccessObjInfos = ({
  successType,
  successContent,
  isSuccessUpsellScreen = false,
}: GetSuccessObjInfosProps) => {
  if (successContent[successType]) {
    return successContent[successType];
  }

  if (isSuccessUpsellScreen) {
    return successContent?.successMessageUpsell;
  }

  return successContent?.default;
};
